<div class="container-fluid">
    <div class="header-container flex">
        <div class="page-header">
            <span class="fa fa-cube"></span>{{ "bikeshop.menu.inventory_audit" | translate }}
        </div>
    </div>
    <div class="content">
        <!-- <div class="row margin-top-8">
          <div class="col-md-6 label"></div>
          <div class="col-md-3 label">
          </div>
          <div class="col-md-3">
            <div class="p-inputgroup">
              <input type="text" pInputText [(ngModel)]="search" placeholder="{{ 'bikeshop.inventory_audit.search' | translate }}" (keyup.enter)="searchInventory()" />
              <span class="p-inputgroup-addon"><i class="fa hubtiger-search" (click)="searchInventory()"></i></span>
            </div>
          </div>
        </div> -->
        <div class="loading" *ngIf="loading">
            <div class="loader"></div>
        </div>
        <!--<div class="row margin-top-16">
          <div pTooltip="Create a new cyclist" tooltipPosition="left" class="fa fa-user-plus font-button pull-right"
            style="margin-left: auto!important;margin-right: 16px!important;" (click)="addUser()"></div>
        </div>-->
        <div class="margin-top-16">
            <p-table #inventoryAuditTable [columns]="columns" [value]="inventoryData">
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th *ngFor="let col of columns">
                            {{ col.header }}
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-record let-columns="columns">
                    <tr [pSelectableRow]="record">
                        <td *ngFor="let col of columns">
                            <div *ngIf="col.type === 'jobcardno'">
                                <div (click)="openJobCard(record.serviceID)" style="cursor: pointer">
                                    <u>{{record[col.field]}}</u></div>
                            </div>
                            <div *ngIf="col.type !== 'jobcardno'" [ngClass]="{
                'status' : col.type === 'status',
                'unprocessed' : col.type === 'status' && record[col.field] === 1,
                'error' : col.type === 'status' && record[col.field] === 2,
                'busy' : col.type === 'status' && record[col.field] === 5,
                'processed' : col.type === 'status' && record[col.field] === 10,
                'noninventory' : col.type === 'status' && record[col.field] === 100
              }">
                                {{
                                col.field === "statusID" ? getStatusDescription(record[col.field])
                                    : col.type === "date" ? (record[col.field] | date : countryData.AngularDateFormat + " h:mma")
                                        : col.field === "stockChanged" ? abs(record[col.field]) + " " + (record[col.field] > 0 ? ('bikeshop.inventory_audit.stock_deducted' | translate) : ('bikeshop.inventory_audit.added_back' | translate))
                                            : record[col.field]
                                }}
                            </div>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
            <p-paginator #paginator [rows]="limit" [totalRecords]="totalRecords"
                         (onPageChange)="paginate($event)"></p-paginator>
        </div>
    </div>
</div>
